import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import { FormControl, FormControlLabel, FormGroup, Stack, Switch, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkBlankSpace, checkNumber, checkSpecialChar } from '../utilities/FormValidation';

const DeliveryTermsForm = () => {

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryTerms}`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [deliveryTermCode, setDeliveryTermCode] = useState("");
    const [termsOfDelivery, setTermsOfDelivery] = useState("");
    const [snackState, setSnackState] = useState(false);
    const [active, setActive] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)
    const [editData, setEditData] = useState();

    const handleSubmit = async () => {
        setCheckSubmit(true);
        let model = {
            deliveryTemCode: Number(deliveryTermCode) ,
            termsOfDelivery: termsOfDelivery,
            isActive: active,
        };

        try {
            if (params.id) {
                if (deliveryTermCode && termsOfDelivery &&
                    !validError.deliveryTermCode && !validError.termsOfDelivery) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/deliveryTerms')},800);
                }
            } else {
                if (deliveryTermCode && termsOfDelivery &&
                    !validError.deliveryTermCode && !validError.termsOfDelivery) {
                    await OAuthService.addData(url, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/deliveryTerms')},800);
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
    }

    /**
        * Tab Change
    */
    function handleTabChange(event, value) {
        setTabValue(value);
    }

    const getDeliveryTerms = async () => {
        try {
            const result = await OAuthService.getEditData(url, params.id);
            const DeliveryTerms = result.data;
            setDeliveryTermCode(DeliveryTerms.deliveryTemCode);
            setTermsOfDelivery(DeliveryTerms.termsOfDelivery);
            setActive(DeliveryTerms.isActive)
            setEditData(DeliveryTerms);
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    useEffect(() => {
        if (params.id) {
            getDeliveryTerms();
            setHideDelete(false)
        }
    }, []);

    const handleDelete = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
            }
        } catch (error) {
            console.log('error', error)
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
        setTimeout(() => { navigate('/deliveryTerms')},800);
    }

    const handleChangeShippingMethod =(e)=>{
        setTermsOfDelivery(e.target.value.toUpperCase());
        // setValidError({...validError, termsOfDelivery: checkSpecialChar(e.target.value) })
    }

    const handleCancel = () => {
        navigate('/deliveryTerms')
    }

    const handleActiveChange = (e) => {
        setActive(e.target.checked);
    };

    useEffect(() => {
        if (termsOfDelivery.trim() && deliveryTermCode && !validError.deliveryTermCode && !validError.termsOfDelivery) {
            if(editData){
                if(termsOfDelivery !== editData.termsOfDelivery || Number(deliveryTermCode) !== editData.deliveryTemCode || active !== editData.isActive){
                    setSaveDisable(false);
                }else{
                    setSaveDisable(true);
                }                
            }else{                
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    },[termsOfDelivery,deliveryTermCode,validError,editData,active]);

    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="DeliveryTerms"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update Delivery Terms" : "Add Delivery Terms"}
                parentBreadcrumbData={[{ pageName: 'DeliveryTerms List', pageLink: '/deliveryTerms' }]}
                error={error}                
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
            >
                <Tabs
                    value={tabValue}
                    textColor="inherit"
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    sx={{ color: "yellow" }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    // ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <Stack className="mb-16">
                            <label>*Delivery Term Code</label>
                            <TextField
                                type="text"
                                name="deliveryTermCode"
                                required
                                value={deliveryTermCode}
                                error={(checksubmit && !deliveryTermCode) || validError.deliveryTermCode ? true : false}
                                helperText={(checksubmit && !deliveryTermCode) ? "This field is required" : validError.deliveryTermCode}
                                onChange={(e) => {setDeliveryTermCode(e.target.value); setValidError({...validError, deliveryTermCode: checkNumber(e.target.value)})}}
                                variant="outlined"
                                inputProps={{
                                    maxLength: 2
                                }}
                            />
                        </Stack>
                        <Stack className="mb-16">
                            <label>*Terms of Delivery</label>
                            <TextField
                                type="text"
                                name="termsOfDelivery"
                                value={termsOfDelivery}
                                error={(checksubmit && !termsOfDelivery) || validError.termsOfDelivery ? true : false}
                                helperText={(checksubmit && !termsOfDelivery) ? "This field is required" : validError.termsOfDelivery}
                                onChange={handleChangeShippingMethod}
                                className="select"
                            />
                        </Stack>
                        <FormGroup>
                                    <FormControlLabel control={<Switch checked={active} onChange={handleActiveChange} />} label="Active" />
                                </FormGroup>
                    </div>
                </FormControl>
            </div>
        </div>
    )
}

export default DeliveryTermsForm